import { Control, Controller, ControllerProps, useFormContext } from 'react-hook-form';
import TextField, { OutlinedTextFieldProps } from '@mui/material/TextField';
import { Tooltip, Typography } from '@mui/material';

export interface FormInputProps extends Omit<ControllerProps, 'name' | 'control' | 'render'> {
    editable?: boolean;
    name: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    control?: Control<any, any>;
    label?: string;
    textFieldProps?: Partial<OutlinedTextFieldProps>;
    preventEnterSubmission?: boolean;
    tooltip?: string;
}

export default function FormInputText({
    editable = true,
    name,
    control,
    label,
    textFieldProps,
    preventEnterSubmission = false,
    tooltip,
    ...rest
}: FormInputProps) {
    const { trigger } = useFormContext();

    return (
        <Tooltip open={tooltip ? undefined : false} title={tooltip}>
            <span>
                <Controller
                    {...rest}
                    name={name}
                    control={control}
                    render={({
                        field: { onChange, value, ...restField },
                        fieldState: { error },
                    }) =>
                        editable ? (
                            <TextField
                                {...textFieldProps}
                                {...restField}
                                helperText={
                                    error?.message ? (
                                        <Typography color="error" variant="caption">
                                            {error?.message}
                                        </Typography>
                                    ) : null
                                }
                                // size="small"
                                error={!!error}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter' && preventEnterSubmission) {
                                        console.log('preventing submission on ENTER key');
                                        e.preventDefault();
                                        e.stopPropagation();
                                        e.bubbles = false;
                                    }
                                }}
                                onChange={(e) => {
                                    onChange(e);
                                    // triggering Yup validation on change
                                    trigger?.(name);
                                }}
                                value={value}
                                fullWidth
                                label={label}
                                margin="dense"
                                variant="outlined"
                            />
                        ) : (
                            <Typography variant="body1" className="value">
                                {value}
                            </Typography>
                        )
                    }
                />
            </span>
        </Tooltip>
    );
}
